import { z } from 'zod';

export type BoardType = z.infer<typeof boardTypeSchema>;
export const boardTypeSchema = z.enum(['standard', 'addon', 'premium']);
